var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"title":"Theme"},on:{"click":_vm.toggle}},[_c('span',[_vm._v(_vm._s(_vm.currentSetting))]),(_vm.isDark)?_c('MoonIcon',{staticClass:"text-yellow-400"}):_c('SunIcon',{staticClass:"text-gray-700"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }